import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import { DEFAULT_SCRIPT_LOAD_STRATEGY, STRATEGY_AFTER_USER_INTERACTION, STRATEGY_IDLE, STRATEGY_POST_HYDRATE, DEFAULT_TARGET_SELECTOR, STRATEGY_OFF_MAIN_THREAD } from './Script.constants';
import { ScriptPropType } from './Script.types';
import { injectScript, removeInjectedScript, resolveAttributes, resolveInlineScript, getRequestIdleCallback } from './Script.utils';
import useUserInteraction from '../../modules/foundation/hooks/use-user-interaction/use-user-interaction';
var defaultProps = {
  src: undefined,
  strategy: DEFAULT_SCRIPT_LOAD_STRATEGY,
  dangerouslySetInnerHTML: undefined,
  children: undefined,
  onLoad: function onLoad() {},
  onError: function onError() {},
  onRemove: function onRemove() {},
  id: undefined,
  targetSelector: DEFAULT_TARGET_SELECTOR
};
export default function Script(props) {
  var src = props.src,
    onRemove = props.onRemove,
    _props$strategy = props.strategy,
    strategy = _props$strategy === void 0 ? DEFAULT_SCRIPT_LOAD_STRATEGY : _props$strategy;
  var _useUserInteraction = useUserInteraction(),
    anyInteraction = _useUserInteraction.anyInteraction;
  var detailsRef = useRef(null);
  useEffect(function () {
    var idleTimeoutId;
    switch (strategy) {
      case STRATEGY_POST_HYDRATE:
        detailsRef.current = injectScript(props);
        break;
      case STRATEGY_IDLE:
        idleTimeoutId = getRequestIdleCallback()(function () {
          detailsRef.current = injectScript(props);
        });
        break;
      default:
        break;
    }
    if (detailsRef.current) {
      return function () {
        return removeInjectedScript(detailsRef.current, onRemove, idleTimeoutId);
      };
    }
    return function () {
      return null;
    };
  }, []);
  useEffect(function () {
    if (anyInteraction && strategy === STRATEGY_AFTER_USER_INTERACTION) {
      detailsRef.current = injectScript(props);
    }
    if (detailsRef.current) {
      return function () {
        return removeInjectedScript(detailsRef.current, onRemove);
      };
    }
    return function () {
      return null;
    };
  }, [anyInteraction]);
  if (strategy === STRATEGY_OFF_MAIN_THREAD) {
    var inlineScript = resolveInlineScript(props);
    var attributes = resolveAttributes(props);
    if (inlineScript) {
      return /*#__PURE__*/React.createElement("script", _extends({
        type: "text/partytown",
        "data-strategy": strategy,
        crossOrigin: "anonymous"
      }, attributes, {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: inlineScript
        }
      }));
    }
    return /*#__PURE__*/React.createElement("script", _extends({
      type: "text/partytown",
      src: src,
      "data-strategy": strategy,
      crossOrigin: "anonymous"
    }, attributes));
  }
  return null;
}
Script.defaultProps = defaultProps;
Script.STRATEGY_POST_HYDRATE = STRATEGY_POST_HYDRATE;
Script.STRATEGY_IDLE = STRATEGY_IDLE;
Script.STRATEGY_OFF_MAIN_THREAD = STRATEGY_OFF_MAIN_THREAD;
Script.STRATEGY_AFTER_USER_INTERACTION = STRATEGY_AFTER_USER_INTERACTION;
Script.DEFAULT_SCRIPT_LOAD_STRATEGY = DEFAULT_SCRIPT_LOAD_STRATEGY;
Script.DEFAULT_TARGET_SELECTOR = DEFAULT_TARGET_SELECTOR;